<template v-slot:append>
  <v-dialog max-width="75%" persistent no-click-animation
        v-bind="computedProps"
        v-on="computedListeners"
        v-model="showDialog">
    <v-card min-height="75%" min-width="75%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <dd-sub-header>
                検索条件
          </dd-sub-header>
          <v-row no-gutters align-content="center">
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-text-box
                      label="定型受注名"
                      v-model="conditions.teikeiKihonNm"
                      ref="teikeiKihonNm"
                      :length=100
                      :valueType="ctypes.InputTypes.Free"
                    />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                      label="営業所コード/名称"
                      v-model="conditions.eigyoshoCd"
                      ref="eigyoshoCd"
                      :length=100
                      :valueType="ctypes.InputTypes.Free"
                      :itemList="filteredEigyopshoList"
                      titleText="営業所検索"
                      item-value="eigyoshoCd"
                      item-text="eigyoshoNm"
                      :headerList="eigyoshoHeader"
                    />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                      label="取引先コード/名称"
                      v-model="conditions.torihikisakiCd"
                      ref="torihikisakiCd"
                      :length=100
                      :valueType="ctypes.InputTypes.Free"
                      :itemList="filteredTorihikisakiList"
                      titleText="取引先検索"
                      item-value="torihikisakiCd"
                      item-text="torihikisakiNm"
                      :headerList="torihikisakiHeader"
                    />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="8">
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-toolbar class="pa-0 ma-0" flat dense>
                  <v-spacer />
                  <dd-default-button
                      class="ml-2"
                      dark
                      dense
                      @click="onSearchButtonClick">
                      検索
                  </dd-default-button>
                  <dd-default-button
                      class="ml-2"
                      dark
                      dense
                      @click="onClearButtonClick">
                      クリア
                  </dd-default-button>
                </v-toolbar>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="6">
              <dd-sub-header>
                一覧
              </dd-sub-header>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box v-model="searchText" :length=10 />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                    label="検索結果"
                    v-model="rowCount"/>
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                    label="絞込結果"
                    v-model="filteredRowCount"/>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="12">
              <dd-data-table
                v-model="selectedItem"
                calculate-widths
                height="25vh"
                item-key="id"
                showSelect
                singleSelect
                @dblclick:row="onRowDoubleClick"
                @click:row="onRowClick"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                :header-props="{sortByText: '並び替え'}"
                :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                loading-text="検索中のため、少々お待ちください。"
                :itemsPerPage=500
                fixed-header
                locale="ja-jp"
                no-data-text="利用可能なデータはありません。"
                dense
                :page.sync ="page"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          @click="onCloseClick">
          閉じる
        </dd-footer-button>
        <v-spacer/>
        <dd-footer-button
          :disabled="isSelectButtonDisabled"
          @click="onSelectButtonClick">
          選択
        </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdSubHeader from '@/components/DdSubHeader'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdTextBox from '@/components/DdTextBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'

import controls from '@/rahmen/controls'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'

import { mapGetters } from 'vuex'

export default {
  name: 'DdTeikeiJutyuKensakuDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdDataTable,
    DdRowCountBox,
    DdCodeTextBox,
    DdTextBox,
    DdDefaultButton,
    DdNarrowDownTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String
  },
  data: () => ({
    conditions: {
      teikeiKihonNm: '',
      eigyoshoCd: '',
      torihikisakiCd: ''
    },
    searchText: '',
    title: '定型受注検索',
    ctypes: controls,
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    selectedItem: [],
    page: 1
  }),
  created () {
    console.log('screen created')
    // this.Effects.loadStart()
    this.$store.dispatch('system/setViewTitle', '定型受注検索')
    this.eigyoshoHeader = header.mstEigyoshoHeaders
    this.torihikisakiHeader = header.mstTorihikisakiHeaders

    /*
    this.eigyoshoHeader = [
      { width: '60px', text: '営業所コード', value: 'eigyoshoCd' },
      { width: '90px', text: '営業所名', value: 'eigyoshoNm' }
    ]
    this.torihikisakiHeader = [
      { width: '60px', text: '取引先コード', value: 'torihikisakiCd' },
      { width: '90px', text: '取引先名', value: 'torihikisakiNm' }
    ]
    */
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho'
    }),
    filteredTorihikisakiList () {
      // 全部出す
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    filteredEigyopshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '80%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.seikyuKingakuDisp = elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : ''
        elem.eigyoshoNmDisp = elem.eigyoshoCd + ' ' + elem.eigyoshoNm
        elem.torihikisakiNmDisp = elem.torihikisakiCd + ' ' + elem.torihikisakiNm
        return elem
      })
    },
    isSelectButtonDisabled () {
      return this.selectedItem.length === 0
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('JutyuKeiyakuKensakuDialog.defineHeaderPromise')
            this.headers = [
              { text: '定型受注名', value: 'teikeiKihonNm' },
              { text: '営業所', value: 'eigyoshoNmDisp' },
              { text: '取引先', value: 'torihikisakiNmDisp' },
              { text: '請求区分', value: 'ikkatsuFlgNm' },
              { text: '請求金額', value: 'seikyuKingakuDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.clear(false)
        },
        savedInputRestorePromise: (c) => {
          console.log('JutyuKeiyakuKensakuDialog.savedInputRestorePromise', c)
          return new Promise(resolve => {
            this.loadFromCacheById('VwCD2comd0110')
              .then((c) => {
                console.log('JutyuKeiyakuKensakuDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('JutyuKeiyakuKensakuDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.search().then(() => {
              resolve()
            })
          })
        },
        restoreViewPromise: (c) => {
          console.log('JutyuKeiyakuKensakuDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('JutyuKeiyakuKensakuDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            conditions: this.conditions
          }
        }
      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      // this.$emit('close', this.getRowData(f.item))
      this.getRowData(f.item)
      this.clear(false)
    },
    onRowClick: function (e) {
      /**
       * 選択処理
       * @event Click
       * @type {Event}
       */
      this.selectedItem = [e]
    },
    onSelectButtonClick: function (e) {
      /**
       * 選択ボタン押下処理
       * @event click
       * @type {Event}
       */
      console.log('select clicked', e, this.selectedItem)
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        // this.$emit('close', this.getRowData(this.selectedItem[0]))
        this.getRowData(this.selectedItem[0])
      }
      this.clear(false)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2comd0110/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChacheById('VwCD2comd0110', cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    // onSearchButtonClick: function (e) {
    //   /**
    //    * 検索ボタン押下処理
    //    * @event click
    //    * @type {Event}
    //    */
    //   const isValid = this.validateAll(this.$refs)
    //   console.log('validate all ', isValid)
    //   if (isValid) {
    //     console.log('serach clicked')
    //     this.search()
    //   }
    // },
    // search: function () {
    //   console.log('serach process')
    //   const self = this
    //   self.loading = true
    //   self.HttpClient
    //     .post('/api/v1/VwCD2comd0110/Search', self.conditions)
    //     .then((data) => {
    //       self._setMessages(data).then(() => {
    //         if (!data.isValid) {
    //           self.loading = false
    //           return
    //         }
    //         self.rows = data.payload

    //         self.saveToChache('VwCD2comd0110', { rows: self.rows, conditions: self.conditions })
    //           .then(() => {
    //             self.loading = false
    //           })
    //       })
    //     }).catch(function (error) {
    //       console.log('post error')
    //       console.log(error)
    //       self.loading = false
    //     })
    // },
    clear: function (isRemainRows) {
      console.log('clear', this.torihikisakiList)
      return new Promise(resolve => {
        this.conditions = {
          teikeiKihonNm: '',
          eigyoshoCd: '',
          torihikisakiCd: ''
        }
        if (!isRemainRows) {
          this.rows = []
          this.searchText = ''
          this.selectedItem = []
        }
        resolve()
      })
    },
    clearExec: function () {
      console.log('clearExec')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('clearExec ...')

            this.conditions = {
              teikeiKihonNm: '',
              eigyoshoCd: '',
              torihikisakiCd: ''
            }
            this.rows = []
            this.searchText = ''
            this.selectedItem = []
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      /**
       * クリアボタン押下処理
       * @event click
       * @type {Event}
       */
      this.Effects.loadStart()
      this.clearExec()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', undefined)
      this.clear(false)
    },
    getRowData: function (rowData) {
      /**
       * 返却行情報作成処理
       * retruns { 定型基本, 定型コース[], 定型品目[] }
       */
      // const self = this

      // console.log('meisai get request', rowData)
      // self.HttpClient
      //   .post('/api/v1/VwCD2comd011001/GetAdditionalInfo', rowData)
      //   .then((data) => {
      //     console.log('meisai returned data', data)
      //     if (data.isValid) {
      //       const CourceData = data.payload
      //       console.log('hinmei get request', CourceData)
      //       self.HttpClient
      //         .post('/api/v1/VwCD2comd011002/GetAdditionalInfo', CourceData)
      //         .then((data) => {
      //           console.log('hinmei returned data', data)
      //           if (data.isValid) {
      //             const HinmokuData = data.payload
      //             self.$emit('close', { mstTeikeiKihon: rowData, mstTeikeiCource: CourceData, mstTeikeiHinmoku: HinmokuData })
      //             return { mstTeikeiKihon: data, mstTeikeiCource: CourceData, mstTeikeiHinmoku: HinmokuData }
      //           } else {
      //             self.$emit('close', { mstTeikeiKihon: rowData, mstTeikeiCource: CourceData, mstTeikeiHinmoku: null })
      //             return { mstTeikeiKihon: data, mstTeikeiCource: CourceData, mstTeikeiHinmoku: null }
      //           }
      //         })
      //     } else {
      //       self.$emit('close', { mstTeikeiKihon: data, mstTeikeiCource: null, mstTeikeiHinmoku: null })
      //       return { mstTeikeiKihon: rowData, mstTeikeiCource: null, mstTeikeiHinmoku: null }
      //     }
      //   })

      const self = this
      var CourceData
      var HinmokuData

      const option = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient
              .post('/api/v1/VwCD2comd011001/GetAdditionalInfo', rowData)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          CourceData = data.payload
        },
        searchRequestPromise2: function () {
          return new Promise(resolve => {
            self.HttpClient
              .post('/api/v1/VwCD2comd011002/GetHinmokuDatas', CourceData)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod2: function (data) {
          HinmokuData = data.payload
          self.$emit('close', { mstTeikeiKihon: rowData, mstTeikeiCource: CourceData, mstTeikeiHinmoku: HinmokuData })
        },
        searchFaildMethod: function (data) {
          self.$emit('close', { mstTeikeiKihon: rowData, mstTeikeiCource: null, mstTeikeiHinmoku: null })
        },
        searchFaildMethod2: function (data) {
          self.$emit('close', { mstTeikeiKihon: rowData, mstTeikeiCource: CourceData, mstTeikeiHinmoku: null })
        }
      }
      this.search2times(option)
    },
    searchValidate: function () {
      return true
    },
    search2times: function (option) {
      const self = this
      const opt = {
        searchRequestPromise: option.searchRequestPromise || self._dummyPromiseMethod,
        searchResultMethod: option.searchResultMethod || self._dummyObjectsMethod,
        searchRequestPromise2: option.searchRequestPromise2 || self._dummyPromiseMethod,
        searchResultMethod2: option.searchResultMethod2 || self._dummyObjectsMethod,
        searchFaildMethod: option.searchRequestPromise3 || self._dummyPromiseMethod,
        searchFaildMethod2: option.searchResultMethod3 || self._dummyObjectsMethod
      }

      opt.searchRequestPromise().then(data => {
        console.log('searchRequestPromise', data)
        if (data.isValid) {
          opt.searchResultMethod(data)
          opt.searchRequestPromise2().then(data => {
            console.log('searchRequestPromise2', data)
            if (data.isValid) {
              opt.searchResultMethod2(data)
            } else {
              opt.searchFaildMethod2(data)
            }
          })
        } else {
          opt.searchFaildMethod(data)
        }
      })
    }

  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 400 !important;
}
</style>
